import React from 'react';
import { connect } from 'react-redux';
import { Route, RouteComponentProps, Switch, withRouter } from 'react-router-dom';

import PageNotFound from '~src/shared/errorPages/PageNotFound';
import TopicAdd from '~src/modules/topics/components/add/TopicAdd';
import TopicDetail from '~src/modules/topics/components/details/TopicDetail';
import TopicsList from '~src/modules/topics/components/list/TopicsList';
import { itemIdMatch } from '~src/constants';
import logger from '~src/services/logger/LlsLogger';
import { ApiReduxResp } from '~src/services/apiMiddleware';
import { fetchTimeZones, fetchLocales } from '~src/store/session/actions';

interface OwnProps {
  isAuthenticated: boolean;
}

interface StateProps {
  defaultContentLocale: string;
  contentLocales: { [key: string]: string };
}

interface DispatchProps {
  fetchTimeZones(): ApiReduxResp<{ [key: string]: string }>;
  fetchLocales(): ApiReduxResp<{ [key: string]: string }>;
}

type Props = OwnProps & StateProps & DispatchProps & RouteComponentProps<any>;

class Topics extends React.Component<Props> {
  componentDidMount() {
    if (this.props.isAuthenticated) {
      Promise.all([
        this.props.fetchTimeZones().then(res => {
          if (res.error) {
            throw new Error('Error on fetching timezones');
          }
        }),
        this.props.fetchLocales().then(res => {
          if (res.error) {
            throw new Error('Error on fetching locales');
          }
        }),
      ]).catch(error => {
        logger.info('Error on fetching Data', {
          error,
          info: {
            componentStack: 'Topics.jsx',
          },
        });
      });
    }
  }
  render() {
    return (
      <Switch>
        <Route exact strict path={this.props.match.url} component={TopicsList} />
        <Route exact strict path={`${this.props.match.url}/add`} component={TopicAdd} />
        <Route
          exact
          strict
          path={`${this.props.match.url}/:topicId(${itemIdMatch})`}
          component={TopicDetail}
        />
        <PageNotFound {...this.props} />
      </Switch>
    );
  }
}

const mapDispatchToProps = (dispatch: any) => ({
  fetchTimeZones: () => dispatch(fetchTimeZones()),
  fetchLocales: () => dispatch(fetchLocales()),
});

const TopicsWithRouter = withRouter(Topics);
const TopicsSuperComponent = connect(null, mapDispatchToProps)(TopicsWithRouter);

export default TopicsSuperComponent;
